import { render } from "./ShowConsulting.vue?vue&type=template&id=179ac581"
import script from "./ShowConsulting.vue?vue&type=script&lang=js"
export * from "./ShowConsulting.vue?vue&type=script&lang=js"

import "./ShowConsulting.vue?vue&type=style&index=0&id=179ac581&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__